<template>
  <v-btn
    v-if="!loading && !extras"
    small
    block
    @click="handleOrder"
    :color="config.BGColor"
    :style="{ color: config.Color }"
  >
    {{ $t('dtouch.dishOrders.order', locale) }}
  </v-btn>
  <div v-else-if="!loading && extras">
      <v-btn
        small
        block
        @click="showExtras = true"
        :color="config.BGColor"
        :style="{ color: config.Color }"
      >
        {{ $t('dtouch.dishOrders.order', locale) }}
      </v-btn>
    <v-row justify="center">
      <v-dialog
        v-model="showExtras"
        persistent
        scrollable
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">
              {{ getTranslation(label, locale) }}
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  v-for="item of extras"
                  :key="item.ExtraID"
                  cols="12"
                  sm="12"
                  md="12"
                  style="padding: 10px 0;"
                >
                  <v-card v-if="config">
                    <table class="extra">
                      <tr>
                        <td
                          style="width: auto;"
                          :style="{ 'color': config.FoodDrinkTextColor ? config.FoodDrinkTextColor : config.ColorContent,
                            'font-size': `${config.FontSizeContent}px`,
                            'font-family': config.FontContent, 
                          }"
                        >
                          {{getTranslation(item.Name, locale)}}
                        </td>
                        <td rowspan="2"
                          style="text-align: right;width:80px !important;vertical-align: middle;"
                        >
                          <v-btn 
                            style="margin: 0 10px 10px 10px;"
                            fab
                            elevation="0"
                            :color="config.BGColor"
                            small
                            dark
                            :style="{ opacity: selectedExtras.indexOf(item.ExtraID) >= 0 ? '60%' : null, cursor: selectedExtras.indexOf(item.ExtraID) >= 0 ? 'default' : 'pointer'}"
                            @click="handleAddExtra(item.ExtraID)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <tr>
                        <td 
                          class="price"
                          style="width: auto;"
                          :style="{ 'color': config.ColorContent,
                            'font-size': `${config.FontSizeContent-5}px`,
                            'font-family': config.FontContent, 
                          }"
                        >
                          {{item.Price}}
                        </td>
                      </tr>
                    </table>
                  </v-card>
                </v-col>
                <v-col
                  v-if="selectedExtras.length > 0"
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-chip
                    v-for="(item, index) of selectedExtras"
                    :key="index"
                    style="margin: 10px 10px 0 0"
                  >
                    {{ getExtra(item, locale) }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions style="padding: 0 20px 20px 0; margin-top: -10px;">
            <v-spacer />
            <v-btn
              @click="handleClose"
            >
              {{ $t('common.cancel', locale) }}
            </v-btn>
            <v-btn
              :color="config.BGColor"
              @click="handleOrder"
              dark
            >
              {{ $t('dtouch.dishOrders.order', locale) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import utils from '@/services/utils'
import apiDishOrders from '@/services/apiDishOrders'
export default {
  props: {
    contentID: {
      type: String,
      required: true,
    },
    onOrder: {
      type: Function,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    label: {
      type: [Object,String],
      default: null,
    },
  },
  data: () => ({
    loading: true,
    extras: null,
    showExtras: false,
    selectedExtras: [],
  }),
  mounted () {
    this.handleGetExtras ()
  },
  methods: {
    getTranslation (v, locale) {
      return utils.getTranslation(v, locale)
    },
    getExtra (v, locale) {
      let aux = this.extras.filter(x => x.ExtraID === v)
      return aux && aux.length > 0 ? utils.getTranslation(aux[0].Name, locale).concat(` (${aux[0].Price})`) : ''
    },
    handleGetExtras () {
      if (!this.contentID) return
      apiDishOrders.getExtras(this.contentID) 
        .then((response) => {
          this.extras = response && response.length > 0 ? response.map(item => {
            item.Name = item.Name ? JSON.parse(item.Name) : { es: '' }
            return item
          }) : null
          this.loading = false
        })
    },
    handleClose () {
      this.selectedExtras = []
      this.showExtras = false
    },
    handleAddExtra (v) {
      if (this.selectedExtras.indexOf(v) >= 0) return
      this.selectedExtras.push(v)
    },
    handleOrder () {
      this.onOrder(this.selectedExtras && this.selectedExtras ? this.selectedExtras : null)
      this.handleClose()
    },
  }
}
</script>
<style scoped>
.extra {
  width: 100%;
}
.extra td {
  padding: 10px 10px 0 10px;
}
.extra .price {
  line-height:1;
  padding: 10px 10px 10px 10px;
}
</style>

